import React, { useState, useCallback } from 'react';
import './nosService.css';
import PiscineI from './assets/piscine.jpg';
import PiscineE from './assets/piscine1.jpg';
import SportImg from './assets/sport1.jpg';
import HammamSaunaImg from './assets/hammam.jpg';
import ConferenceImg from './assets/salle.jpg';
import Plage from './assets/plageP.jpg';
import Parking from './assets/parking1.jpg';
import { motion } from "framer-motion";

const services = [
  {
    id: 'PiscineI',
    title: "Piscine Intérieure",
    image: PiscineI,
    description: "Plongez dans notre piscine intérieure chauffée, parfaite pour se détendre toute l'année.",
    details: [
      ["Hauteur", "1.40m"],
      ["Bassin enfants", "50 cm"],
    ]
  },
  {
    id: 'PiscineE',
    title: "Piscine Extérieure",
    image: PiscineE,
    description: "Rafraîchissez-vous dans notre piscine extérieure avec vue panoramique.",
    details: [
      ["Hauteur", "1.40"],
      ["Bassin enfants", "50 cm"],  
    ]
  },
  {
    id: 'Sport',
    title: "Salle de Sport",
    image: SportImg,
    description: "Gardez la forme grâce à notre salle de sport équipée.",
    details: [
      ["Équipements", "Cardio, musculation, yoga"],
      ["Accès", "Gratuit pour tous les résidents"]
    ]
  },
 
  {
    id: 'Hammam&Sauna',
    title: "Espace Hammam & Sauna",
    image: HammamSaunaImg,
    description: "Un univers de détente : sauna, hammam traditionnel et jacuzzi vous attendent pour un moment de pur bien-être.",
    details: [
      ["Température Sauna", "80°C"],
      ["Température Hammam", "45°C"],
      ["Accès", "Inclus avec SPA ou sur demande"]
    ]
  },

  {
    id: 'SallePolyvalente',
    title: "Salle polyvalente",
    image: ConferenceImg,
    description: "Une salle polyvalente spacieuse , idéale pour vos réceptions, séminaires et événements sur mesure.",
    details: [
      ["Capacité", "200 couverts, 350 places assises"],
      ["Réservation", "À l'avance auprès de la réception"]
    ]
  },
  {
    id: 'SalleFete',
    title: "Salle des Fêtes",
    image: ConferenceImg,
    description: "Découvrez notre salle de fête avec terrasse panoramique et vue imprenable sur la mer, le cadre idéal pour célébrer mariages, réceptions et événements privés inoubliables.",
    details: [
      ["Capacité", "plus de 200 personnes"],
      ["Réservation", "À l'avance auprès de la réception"]
    ]
  },
  {
  id: 'Plage',
  title: "Plage Privée",
  image: Plage,
  description: "Profitez de notre plage privée, accessible directement depuis l’hôtel, exclusivement réservé à nos résidents.",
  details: [
    ["Surface", " 2 500 m²,"],
  ]
},
  {
    id: 'Parking',
    title: "Parking Sécurisé",
    image: Parking,
    description: "L'hotel dispose aussi d'un parking surveillé par nos agents ",
    details: [
      ["Capacité", "135 places"],
      ["survaillance", "24h/24h"]
    ]
  },
];

const NosServices = () => {
  const [expandedItem, setExpandedItem] = useState(null);

  const handleExploreClick = useCallback((id) => {
    setExpandedItem(prev => prev === id ? null : id);
  }, []);

  return (
    <div className="main-section-service" id='services'>
      <h1>Nos Services</h1>
      <div className="nosService">
        {services.map((service, index) => (
          <motion.div
            key={service.id}
            className="service-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2, ease: 'easeInOut' }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <div className="ContenuService">
              <img 
                src={service.image} 
                alt={service.title} 
                className="content-image3"
                loading="lazy"
              />
              <div className="description">
                <h2>{service.title}</h2>
                <p>{service.description}</p>
                <button 
                  className="buttonSr" 
                  onClick={() => handleExploreClick(service.id)}
                  aria-expanded={expandedItem === service.id}
                >
                  {expandedItem === service.id ? 'Show Less' : 'Explore More'}
                </button>
                {expandedItem === service.id && (
                  <div className="details-section2">
                    <h3>Détails {service.title.toLowerCase()}</h3>
                    {service.details.map(([label, value], i) => (
                      <p key={i}><strong>{label}:</strong> {value}</p>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default NosServices;
